import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { Grid, Button } from "@material-ui/core";
import emmerce from "./../img/emmerce.svg";
import portafolio from "./../img/portafolio.svg";
import nets from "./../img/nets.svg";
import idea from "./../img/icons/idea2.svg";
import webcorp from "./../img/webcorp.svg";
import blogs from "./../img/blogs.svg";
class MainServices extends Component {
  render() {
    return (
      <div className="MainServices">
        <div className="titleMain">
          <h1>Te ayudamos a crecer en el mundo digital</h1>
          <img src={idea} alt="cohete" className="img-fluid headerIllus1" />
        </div>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="stretch"
            className="contMain"
          >
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textIllus"
            >
              <img
                src={emmerce}
                alt="Tienda virtual"
                className="img-fluid headerIllus1"
              />
            </Grid>
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textMain"
            >
              <h2>Tiendas virtuales</h2>
              <p>
                Utiliza el comercio electrónico y todas sus herramientas
                tecnológicas para aumentar tus ventas. Lleva tu negocio al mundo
                digital, incrementa su alcance y genera más clientes. Crea una
                tienda online hoy mismo que abra las 24 horas y prepárate para
                el futuro!
              </p>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                component={Link}
                to="/services/tienda/#"
                className="btntime"
              >
                Nuestros planes
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="stretch"
            className="contMain"
          >
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textIllus"
            >
              <img
                src={portafolio}
                alt="Portafolio Web"
                className="img-fluid headerIllus1"
              />
            </Grid>
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textMain"
            >
              <h2>Portafolio web</h2>
              <p>
                Expón tu trabajo al mundo digital, muestra tu portafolio,
                curriculum, experiencia y lo que sabes hacer de forma seria,
                original y profesional mediante una página web personalizada.
                Incrementa tu alcance para generar nuevos clientes o contáctos
                dentro de tu área.
              </p>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                component={Link}
                to="/services/portafolio/#"
                className="btntime"
              >
                Nuestros planes
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="stretch"
            className="contMain"
          >
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textIllus"
            >
              <img
                src={webcorp}
                alt="Web corporativa"
                className="img-fluid headerIllus1"
              />
            </Grid>
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textMain"
            >
              <h2>Web Corporativa</h2>
              <p>
                Da una imágen profesional y seria a tu empresa mediante una web
                corporativa que exponga al mundo digital la identidad de tu
                negocio. Brinda información a los usuarios y empleados,
                incrementa la comunicación e interacción y abra las puertas a
                miles de oportunidades.
              </p>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                component={Link}
                to="/services/corporativa/#"
                className="btntime"
              >
                Nuestros planes
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="stretch"
            className="contMain"
          >
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textIllus"
            >
              <img
                src={nets}
                alt="Marketing Digital"
                className="img-fluid headerIllus1"
              />
            </Grid>
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textMain"
            >
              <h2>Marketing digital</h2>
              <p>
                Haz llegar tu producto o servicio a miles de personas mediante
                la implementación de campañas publicitarias basadas en
                estrategias personalizadas de marketing para llegar a tu cliente
                ideal y aumentar tus ventas.
              </p>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                component={Link}
                to="/services/marketing/#"
                className="btntime"
              >
                Nuestros planes
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="stretch"
            className="contMain"
          >
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textIllus"
            >
              <img
                src={blogs}
                alt="Blogs y foros"
                className="img-fluid headerIllus1"
              />
            </Grid>
            <Grid
              item
              container
              direction="column"
              justify="center"
              alignItems="center"
              xs={12}
              sm={4}
              className="textMain"
            >
              <h2>Blogs - foros</h2>
              <p>
                Crea un espacio personalizado para tu contenido y para tus
                seguidores, muestra tus publicaciones de una forma original e
                interactua y fideliza a tus visitantes. Gana una mejor
                reputación online y aumenta tu alcance.
              </p>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                component={Link}
                to="/services/blog/#"
                className="btntime"
              >
                Nuestros planes
              </Button>
            </Grid>
          </Grid>
      </div>
    );
  }
}

export default MainServices;
